import React, { useState } from 'react';
import { Modal, Box, Typography, TextField, Button, Alert } from '@mui/material';
import { createAccount } from '../services/api';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '90%', sm: 400 },
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: { xs: 2, sm: 3, md: 4 },
  maxHeight: '90vh',
  overflowY: 'auto'
};

function AddAccountModal({ open, handleClose, onAccountAdded }) {
  const [accountName, setAccountName] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    try {
      await createAccount(accountName);
      onAccountAdded();
      handleClose();
      setAccountName(''); // Clear form
    } catch (err) {
      console.error("Failed to add account", err);
      setError(err.response?.data?.msg || 'Failed to add account');
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} component="form" onSubmit={handleSubmit}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Add New Account
        </Typography>
        {error && <Alert severity="error" sx={{ mt: 2, mb: 2 }}>{error}</Alert>}
        <TextField
          margin="normal"
          required
          fullWidth
          label="Account Name"
          value={accountName}
          onChange={(e) => setAccountName(e.target.value)}
          sx={{ 
            '& .MuiInputBase-input': { 
              fontSize: { xs: '16px', md: '14px' }
            }
          }}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
        >
          Add Account
        </Button>
        <Button
          fullWidth
          variant="outlined"
          onClick={handleClose}
        >
          Cancel
        </Button>
      </Box>
    </Modal>
  );
}

export default AddAccountModal;
